<template>
  <div id="orderData">
    <!-- INVOICE DATAS && ATTACHMENTS -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6">
        <h2 class="mb-3">{{ $t("orderDetails.invoiceDetails") }}</h2>
        <v-row class="pl-2 mt-3">
          <v-col
            cols="12"
            class="pa-0"
            v-for="(item, index) in invoiceDatas"
            :key="index"
          >
            <div class="object-container">
              <v-col cols="6" class="itemName pb-0 pt-0"
                >{{ item.name }}:</v-col
              >
              <v-col
                v-if="item.value !== '-'"
                cols="6"
                class="pb-0 pt-0 itemValue"
                :class="
                  item.name == this.$t('orderDetails.table.link') ? 'link' : ''
                "
                @click="handleClick(item.name, item.value)"
                >{{
                  item.name == this.$t("orderDetails.table.link")
                    ? this.$t("orderDetails.openLink")
                    : getInvoiceNumber(item.value)
                }}</v-col
              >
              <v-col v-else cols="6" class="pb-0 pt-0 itemValue">
                {{ item.value }}
              </v-col>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="6">
        <h2 class="mb-3">{{ this.$t("orderDetails.attachments") }}</h2>
        <v-row class="pl-2 mt-3">
          <v-col
            cols="12"
            class="pa-0"
            v-for="(item, index) in attachments"
            :key="index"
          >
            <div class="object-container">
              <v-col cols="6" class="itemName pb-0 pt-0"
                >{{ item.name }}:</v-col
              >
              <v-col
                v-if="item.value !== '-'"
                cols="6"
                class="pb-0 pt-0 itemValue link"
                @click="
                  item.name == this.$t('orderDetails.table.ical')
                    ? this.getIcal()
                    : openLink(item.value)
                "
                >{{ this.$t("orderDetails.downloadAttachment") }}</v-col
              >
              <v-col v-else cols="6" class="pb-0 pt-0 itemValue">
                {{ item.value }}
              </v-col>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- STATUS CHANGES -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6">
        <h2 class="mb-3">{{ $t("orderDetails.statusChanges") }}</h2>
        <v-row class="pl-2 mt-3 bordered">
          <v-col
            cols="12"
            class="pa-0"
            v-for="(item, index) in statusChanges"
            :key="index"
          >
            <div class="object-container" v-if="!item.separator">
              <v-col cols="6" class="itemName pb-0 pt-0"
                >{{ item.name }}:</v-col
              >
              <v-col cols="6" class="pb-0 pt-0 itemValue">{{
                item.value
              }}</v-col>
            </div>
            <div v-if="item.separator"><br /></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- PAYMENT PROVIDER -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6">
        <h2 class="mb-3">{{ $t("orderDetails.paymentInfo") }}</h2>
        <v-row class="pl-2 mt-3 bordered">
          <v-col cols="12" class="pa-0">
            <div class="object-container">
              <v-col cols="6" class="itemName pb-0 pt-0"
                >{{ $t("orderDetails.paymentProvider") }}:</v-col
              >
              <v-col cols="6" class="pb-0 pt-0 itemValue">
                {{
                  this.$t(
                    `enums.serviceProvider.${this.userData.payment_provider}`
                  )
                }}
              </v-col>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- ARTICLE DATAS-->
    <v-row class="mb-4">
      <v-col cols="12" sm="6">
        <h2 class="mb-3">{{ $t("orderDetails.itemDetails") }}</h2>
        <v-row class="pl-2 mt-3 bordered">
          <v-col
            cols="12"
            class="pa-0"
            v-for="(item, index) in articleDatas"
            :key="index"
          >
            <div class="object-container" v-if="!item.separator">
              <v-col cols="6" class="itemName pb-0 pt-0"
                >{{ item.name }}:</v-col
              >
              <v-col cols="6" class="pb-0 pt-0 itemValue">{{
                item.value
              }}</v-col>
            </div>
            <div v-if="item.separator"><br /></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "OrderDataPopper",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      userData: {},
      invoiceDatas: [],
      attachments: [],
      statusChanges: [],
      articleDatas: [],
    };
  },
  async mounted() {
    await this.getUserData();
    this.separateArrays();
  },
  methods: {
    ...mapActions({
      getUserOrder: "users/getUserOrder",
      getOrderIcal: "users/getOrderIcal",
    }),

    handleClick(name, value) {
      if (name == this.$t("orderDetails.table.link")) {
        this.openLink(value);
      }
    },

    getInvoiceNumber(link) {
      if (link) {
        const numberArr = link.split("|");
        return numberArr[2];
      } else {
        return undefined;
      }
    },

    getIcal() {
      const payload = {
        order_id: this.id,
      };
      this.getOrderIcal(payload)
        .then((res) => {
          const blob = new Blob([res], { type: "text/calendar" });
          const url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .catch((err) => {
          console.error(err);
        });
    },

    formatDate(dateString) {
      return moment(dateString).format("YYYY.MM.DD");
    },

    openLink(link) {
      window.open(link, "_blank");
    },

    async getUserData() {
      await this.getUserOrder({ id: this.id })
        .then((res) => {
          this.userData = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    separateArrays() {
      this.invoiceDatas = [
        {
          name: this.$t("orderDetails.table.documentNumber"),
          value:
            this.userData.invoice && this.userData.invoice.response_data
              ? this.userData.invoice.response_data
              : "-",
        },
        {
          name: this.$t("orderDetails.table.link"),
          value:
            this.userData.invoice && this.userData.invoice.invoice_link
              ? this.userData.invoice.invoice_link
              : "-",
        },
      ];

      this.attachments = [
        {
          name: this.$t("orderDetails.table.ical"),
          value:
            this.userData.attachments && this.userData.attachments.ical
              ? this.userData.attachments.ical
              : "-",
        },
        {
          name: this.$t("orderDetails.table.ticket"),
          value:
            this.userData.attachments && this.userData.attachments.ticket
              ? this.userData.attachments.ticket
              : "-",
        },
        {
          name: this.$t("orderDetails.table.voucher"),
          value:
            this.userData.attachments && this.userData.attachments.voucher
              ? this.userData.attachments.voucher
              : "-",
        },
      ];

      this.userData.order_status_histories.forEach((element) => {
        this.statusChanges.push(
          {
            name: this.$t("orderDetails.table.changeDate"),
            value:
              element && element.created_at
                ? this.formatDate(element.created_at)
                : "-",
          },
          {
            name: this.$t("orderDetails.table.oldStatus"),
            value:
              element && element.old_status
                ? this.$t(`orders.table.status.${element.old_status}`)
                : "-",
          },
          {
            name: this.$t("orderDetails.table.newStatus"),
            value:
              element && element.new_status
                ? this.$t(`orders.table.status.${element.new_status}`)
                : "-",
          },
          { separator: true }
        );
      });

      this.userData.items.forEach((element) => {
        this.articleDatas.push(
          {
            name: this.$t("orderDetails.table.orderDate"),
            value:
              element && element.created_at
                ? this.formatDate(element.created_at)
                : "-",
          },
          {
            name: this.$t("orderDetails.table.utilization"),
            value:
              element && element.used === false
                ? this.$t(`orderDetails.utilization.${element.used}`)
                : element.used === true
                ? this.$t(`orderDetails.utilization.${element.used}`)
                : "-",
          },
          {
            name: this.$t("orderDetails.table.quantity"),
            value: "1 db",
          },
          { separator: true }
        );
      });
    },
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
#orderData {
  padding: 25px;
  padding-top: 0px;
}
.object-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  .itemName {
    font-weight: 700;
    color: #00000099;
  }
}

.itemValue {
  color: #000000de;
}
.link {
  text-decoration: underline;
  cursor: pointer;
}
.bordered {
  border-bottom: 1px solid #a9a9a9;
}
</style>
